import { ifxJsonAjax, useObservable } from "@ifx-react/ifx-react-core";
import { useMemo } from "react";
import { catchError, map } from "rxjs/operators";
import { ASMTasks } from "../../../../../const/asm/ASMTaskConsts";
import { GET_ASM_MENU } from "../../../../../const/common/endpoints";
import { useUserTaskGranted } from "../../../../../hooks/portal/userSecurityHooks";
import { SpecManagerMenu } from "./ESMNavItems";
import { ServiceOrderingMenu } from "./ESONavItems";
import { ServiceSchedulingMenu } from "./ESSNavItems";
import { ServiceValidationMenu } from "./ESVNavItems";
import { GalleyPlanningMenu } from "./GPNavItems";
import { IFXHomeMenu } from "./PortalNavItems";
import { ReportsMenu } from "./ReportsNavItems";
import { SPMTMenu } from "./SPMTNavItems";

const asmMenuObsv$ = ifxJsonAjax
  .get(`${GET_ASM_MENU}?preventCache=${new Date().getTime()}`)
  .pipe(
    map(xhrResponse => {
      return xhrResponse.response;
    }),
    catchError(error => {
      console.error("ASM Menu API Error:", error);
      return [];
    })
  );

const ALL_IFX_MENUS = [
  IFXHomeMenu,
  SpecManagerMenu,
  ServiceSchedulingMenu,
  ServiceOrderingMenu,
  ServiceValidationMenu,
  GalleyPlanningMenu,
  ReportsMenu,
  SPMTMenu,
];

export const useIFXMenus = () => {
  const hasAssetMgmtTasks = useUserTaskGranted(ASMTasks.VIEW_DASHBOARD);

  const ASMMenu = useObservable(
    asmMenuObsv$,
    null,
    [hasAssetMgmtTasks],
    hasAssetMgmtTasks
  );
  return useMemo(() => {
    if (ASMMenu != null) {
      return [...ALL_IFX_MENUS, ASMMenu];
    }
    return ALL_IFX_MENUS;
  }, [ALL_IFX_MENUS, ASMMenu]);
};
